import React from 'react';
import * as Yup from 'yup';
import MasterManager from '../../components/expense/MasterManager';
import useExpenseLookups, { withCurrent } from '../../components/expense/useExpenseLookups';

const schema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required').max(200),
  countryId: Yup.string().required('Country is required'),
  type: Yup.string().trim().max(60),
  email: Yup.string().trim().email('Enter a valid email').max(200),
  phone: Yup.string().trim().max(40),
  taxNo: Yup.string().trim().max(60),
});

// Owner: Accounts
const VendorMaster = ({ canEdit }) => {
  const { countries } = useExpenseLookups(canEdit ? ['countries'] : []);

  return (
    <MasterManager
      resource="vendors"
      title="Vendor"
      canEdit={canEdit}
      searchPlaceholder="Search name / email / tax no."
      columns={[
        { key: 'name', label: 'Name' },
        { key: 'country', label: 'Country', render: (r) => r.countryId?.name || '' },
        { key: 'type', label: 'Type' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'taxNo', label: 'Tax No.' },
      ]}
      fields={(editing) => [
        { name: 'name', label: 'Name', required: true },
        {
          name: 'countryId', label: 'Country', type: 'autocomplete', required: true,
          options: withCurrent(countries, editing?.countryId?._id, editing?.countryId?.name),
        },
        { name: 'type', label: 'Type', xs: 6 },
        { name: 'taxNo', label: 'Tax No.', xs: 6 },
        { name: 'email', label: 'Email', xs: 6 },
        { name: 'phone', label: 'Phone', xs: 6 },
      ]}
      validationSchema={schema}
      emptyValues={{ name: '', countryId: '', type: '', email: '', phone: '', taxNo: '' }}
      toForm={(r) => ({
        name: r.name || '',
        countryId: r.countryId?._id || '',
        type: r.type || '',
        email: r.email || '',
        phone: r.phone || '',
        taxNo: r.taxNo || '',
      })}
      toPayload={(v) => ({ name: v.name, countryId: v.countryId, type: v.type, email: v.email, phone: v.phone, taxNo: v.taxNo })}
    />
  );
};

export default VendorMaster;
